'use client';
import React from 'react';
import styled from 'styled-components';
import ContentText from '../atoms/ContentText';
import Link from 'next/link';

const BreadcrumbContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0 8px;
  align-self: flex-start;
  flex-wrap: wrap;
  .ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .word-break {
    word-break: break-all;
  }
  .nowrap {
    white-space: nowrap;
  }
  a:hover {
    color: var(--node-todo, #71717a);
  }
  a {
    color: inherit;
  }
`;

export type BreadcrumbItem = {
  label: string;
  url?: string;
};

type BreadcrumbProps = {
  items: BreadcrumbItem[];
};

const BreadCrumb: React.FC<BreadcrumbProps> = ({ items }) => {
  return (
    <BreadcrumbContainer>
      {items.map((item, index) => (
        <React.Fragment key={index}>
          {item.url && index != items.length - 1 ? (
            <React.Fragment>
              <Link href={item.url} className="nowrap">
                {item.label}
              </Link>
              <ContentText className="ellipsis" type="article-l">
                &gt;
              </ContentText>
            </React.Fragment>
          ) : (
            <ContentText className="ellipsis word-break" type="article-l">
              {item.label}
            </ContentText>
          )}
        </React.Fragment>
      ))}
    </BreadcrumbContainer>
  );
};

export default BreadCrumb;
